import request from '@/config/axios'

export const createPay = (data: any) => {
  return request.post({
    url: '/pay/create',
    data
  })
}

export const createAgentPay = (data: any) => {
  return request.post({
    url: '/pay/agent/create',
    data
  })
}

export const getRegistrationCode = (orderNo: any) => {
  return request.get({
    url: '/pay/agent/registration/code/get?orderNo='+orderNo
  })
}